export default __webpack_public_path__ + "static/media/workspace_bg.615f5bd4.png";